import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';

const StatusColorLabel = ({ color, label, height = 16 }) => (
  <Flex alignItems="center">
    <StatusColorIndicator
      statusColor={color}
      style={{ height, width: 4, marginRight: 6 }}
    />
    <span>{label}</span>
  </Flex>
);

export default StatusColorLabel;
